import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import SlayerMasterSearch from "./SlayerMasterSearch.js";

// Helper function to get icon paths from public directory
const masterIcons = (path) => {
  // path comes in as "./filename.png", we want "/icons/filename.png"
  const filename = path.replace('./', '');
  return `/icons/${filename}`;
};

const SlayerMasterSection = ({ slayerMasters, setSlayerMasterName }) => {
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    setFilteredData(slayerMasters);
  }, [slayerMasters]);

  const handleSearch = (value) => {
    const filtered = slayerMasters.filter((master) =>
      master.master_name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const onSelect = (value) => {
    handleSearch(value);
    setSlayerMasterName(value);
  };

  const selectedMaster =
    Object.keys(filteredData).length === 1 && filteredData[0];
  const notesArray =
    selectedMaster.notes && selectedMaster.notes.length
      ? selectedMaster.notes.split("\n")
      : [];

  return (
    <SlayerMasterContainer>
      <SlayerMasterSearch
        {...{ slayerMasters, onSelect, onSearch: handleSearch, masterIcons }}
      />
      {selectedMaster && (
        <CardContainer>
          <CardHeader>{selectedMaster.master_name}</CardHeader>
          <ImageContainer>
            <img
              style={{
                width: "50px",
                height: "auto",
                marginBottom: "16px",
                objectFit: "cover",
              }}
              src={masterIcons(`./${selectedMaster.master_img}`)}
              alt={`OSRS ${selectedMaster.master_name} Slayer Master Icon`}
            />
            {selectedMaster.notes && (
              <Tooltip
                placement={"right"}
                title={
                  <ul>
                    {notesArray.map((note, i) => (
                      <li key={i}>{note}</li>
                    ))}
                  </ul>
                }
                color={"rgba(0, 0, 0, 0.6)"}
              >
                <InfoCircleOutlined style={{ marginLeft: "5px" }} />
              </Tooltip>
            )}
          </ImageContainer>
          <CardInfo>
            Required Level: <strong>{selectedMaster.required_lvl}</strong>
          </CardInfo>
          <CardInfo>
            Points per Task: <strong>{selectedMaster.points_per_task}</strong>
          </CardInfo>
        </CardContainer>
      )}
    </SlayerMasterContainer>
  );
};

export default SlayerMasterSection;

const SlayerMasterContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #3b3b3b;
  color: #ffff00;
  width: 100%;
  max-width: 350px;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 20px auto;
  text-align: center;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 90%;
    padding: 10px;
  }
`;

const CardHeader = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

const CardInfo = styled.div``;
